import { CheckBroadcastIsSupport } from "@/broadcastChannel/tabChannel";
import { BroadcastDisconnectNotificationAllTab, BroadcastReCreateTab } from "@/broadcastChannel/userChannel";
import { GetCookie } from "@/helper/shareHelper";
import {
  ClearMasterTabFromCookies,
  ClearTabFromSessionStorage,
  GetAllTabs,
  GetTabIdFromSessionStorage,
  InsertTabIdToTabDB,
  IsMasterTab,
  IsMasterTabAvailable,
  SetMasterTab,
  UpdateTabMerchantId,
} from "@/helper/tabHelper";
import { AccessToken, UserId } from "@/helper/userHelper";
import { CheckIndexedDBIsSupport, ClearTabFromIndexedDB } from "@/IndexedDB/tabIndexedDB";
import store from "@/store";
import Cookies from "js-cookie";
import Vue from "vue";

const appVue = new Vue();

const socketSessionIdKey = "socketPeakPayrollSessionId";

export const GetSocketSessionIdFromCookies = () => {
  const socketSessionId = GetCookie(socketSessionIdKey);
  return socketSessionId ? socketSessionId : null;
};

export const SetSocketSessionIdFromCookies = () => {
  if (appVue.$socket && appVue.$socket.connected) {
    const socketSessionId = appVue.$socket.id;
    Cookies.set(socketSessionIdKey, socketSessionId);
  }
};

export const RemoveSocketSessionIdFromCookies = () => {
  Cookies.remove(socketSessionIdKey);
};

export const CheckStatusSocket = () => {
  if (IsMasterTab()) {
    if (!appVue.$socket || appVue.$socket.disconnected) {
      appVue.$socket.connect();
    }
  } else if (appVue.$socket && appVue.$socket.connected) {
    appVue.$socket.disconnect();
  }
};

export const SocketConnect = () => {
  if (IsMasterTab()) {
    if (appVue.$socket && appVue.$socket.disconnected) {
      appVue.$socket.connect();
    }
  } else if (!IsMasterTabAvailable()) {
    SetMasterTab();
    if (appVue.$socket && appVue.$socket.disconnected) {
      appVue.$socket.connect();
    }
  } else {
    store.commit("Notification/MutationSetNotificationReadyToUse", true, { root: true });
  }
};

export const SocketAuthentication = () => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    const eui = btoa(UserId());
    const accessToken = AccessToken();
    appVue.$socket.emit("authentication", {
      eui: eui,
      accessToken: accessToken,
    });
  }
};

export const SocketDisconnect = () => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    appVue.$socket.disconnect();
  }
};

export const CheckMerchantIsActiveOtherTab = async (merchantId: number) => {
  const tabId = GetTabIdFromSessionStorage();
  if (tabId) {
    const allTabs = await GetAllTabs();
    return allTabs.some((x) => x.id !== tabId && x.merchantId == merchantId);
  }
  return false;
};

export const CheckMerchantIsActive = async (merchantId: number) => {
  let isActive = false;
  if (merchantId > 0) {
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      const allTabs = await GetAllTabs();
      const isHaveSomeTabSameMerchant = allTabs.some((x) => x.merchantId == merchantId);
      if (isHaveSomeTabSameMerchant) {
        isActive = true;
      }
    } else {
      isActive = true;
    }
  }
  return isActive;
};

export const ForceSetMaster = async (merchantId: number) => {
  BroadcastDisconnectNotificationAllTab();
  ClearMasterTabFromCookies();
  ClearTabFromSessionStorage();
  await ClearTabFromIndexedDB();
  await InsertTabIdToTabDB();
  await UpdateTabMerchantId(merchantId);
  BroadcastReCreateTab();
};
